export default class View {
	constructor({ type, element, config = {}, lenis = null, services = {} }) {
		this.type = type
		this.element = element
		this.config = config
		this.lenis = lenis
		this.services = services

		this.contentSelector = config.contentSelector || '[data-view-scroll-content]'

		this.closeOnOutsideClick = config.closeOnOutsideClick || null
		this.onOutsideClick = this.onOutsideClick.bind(this)

		this.onOpen = config.onOpen || (() => {})
		this.onClose = config.onClose || (() => {})
		this.onContentLoaded = config.onContentLoaded || (() => {})
		this.onInitComponents = config.onInitComponents || (() => {})

		this.closeOnEscape = config.closeOnEscape === true
		this.lockBrowserScroll = config.lockBrowserScroll === true

		this.closeBtn = this.element.querySelector('.js-close-view')
		this.closeBtns = Array.from(this.element.querySelectorAll('.js-close-view'))

		this.initElements = config.initElements || (() => ({}))

		this.backdrop = this.element.querySelector(config.backdropSelector || '.js-view-backdrop')

		this.elements = {
			view: this.element,
			backdrop: this.backdrop,
			transitionLayer: document.querySelector('.js-views-transitions'),
			...this.initElements(this),
		}

		this.handleClose = this.handleClose.bind(this)
		this.onKeyDown = this.onKeyDown.bind(this)
	}

	mount() {
		this.closeBtns.forEach((btn) => btn.addEventListener('click', this.handleClose))
		if (this.backdrop) this.backdrop.addEventListener('click', this.handleClose)
		if (this.closeOnEscape) document.addEventListener('keydown', this.onKeyDown)

		if (this.closeOnOutsideClick) {
			requestAnimationFrame(() => {
				document.addEventListener('click', this.onOutsideClick)
			})
		}
	}

	unmount() {
		this.closeBtns.forEach((btn) => btn.removeEventListener('click', this.handleClose))
		if (this.backdrop) this.backdrop.removeEventListener('click', this.handleClose)
		document.removeEventListener('keydown', this.onKeyDown)

		if (this.closeOnOutsideClick) {
			document.removeEventListener('click', this.onOutsideClick)
		}
	}

	onKeyDown(e) {
		if (e.key === 'Escape') this.handleClose()
	}

	setContent(html) {
		const container = this.element.querySelector(this.contentSelector)
		if (container) container.innerHTML = html

		this.initComponents(container)
		this.onContentLoaded(this)
	}

	initComponents(container) {
		const target = container || this.element
		const cm = this.services?.componentsManager
		if (cm?.loadComponents && target) {
			cm.loadComponents(target)
		}
		this.onInitComponents(this)
	}

	destroyComponents() {
		const cm = this.services?.componentsManager
		if (cm?.removeComponents) {
			cm.removeComponents(this.element)
		}
	}

	onOutsideClick(e) {
		const target = typeof this.closeOnOutsideClick === 'string' ? this.element.querySelector(this.closeOnOutsideClick) : this.closeOnOutsideClick

		if (!target) return
		if (!target.contains(e.target)) {
			this.handleClose()
		}
	}

	async open() {
		// If content is static, make sure components are initializedr
		if (this.config?.static === true || this.config?.loadContent === false) {
			this.initComponents()
		}

		await this.onOpen(this)
	}

	async close() {
		this.destroyComponents()
		await this.onClose(this)
	}

	handleClose() {
		this.element.dispatchEvent(new CustomEvent('view:close', { bubbles: true }))
	}
}
